<script>
    import Profile from './Profile.svelte';
    import About from './About.svelte';
    import Skillset from './Skillset.svelte';
    import Projects from './Projects.svelte';
    import SocialMedia from './SocialMedia.svelte';
    import Gallery from './Gallery.svelte';
</script>

<main>
    <Profile />
    <About />
    <Skillset />
    <Projects />
    <Gallery />
    <SocialMedia />
</main>

<style>
    main {
        width: 100%;
    }
</style>